import { Component } from "@angular/core";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
import { AccountService } from "app/_services/account.service";
import { SpreadsheetValidateService } from "app/_services/spreadsheetValidation.service";
import { CommonservicesService } from "app/_services/commonservices.service";
import { NotificationService } from "app/_services/notification.service";
import { SpreadsheetFileHandler } from "app/core/handlers/spreadsheet-file-handler";

@Component({
  selector: 'app-bulk-user-register',
  templateUrl: './bulk-user-register.component.html',
  styleUrls: ['./bulk-user-register.component.css']
})
export class BulkUserRegisterComponent extends SpreadsheetFileHandler{
  currentUser: UserModel;
  uploadFileName: string;
  uploadFileContent: string;
  file: File;
  isLoaderResult = false;
  isSuperAdmin : boolean = false;

  constructor(
    protected readonly datePipe: DatePipe,
    protected readonly notify: NotificationService,
    protected readonly spreadsheetService:SpreadsheetValidateService,
    private readonly accountService:AccountService,
    private readonly commonService:CommonservicesService,
  ) {
     super(spreadsheetService, datePipe, notify);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let roles = this.currentUser.roles;
    if (roles.length > 0) {
      roles = roles.map(function (x) {
        return x.toUpperCase();
      });
      if (roles.includes("SUPERADMIN")) {
        this.isSuperAdmin = true;
      }
    }

   }

 downLoadFile()
 {
  this.downloadFileHelper(
      this.accountService.getSampleFileForBulkUserRegister(),
      "SampleBulkUserRegister"
    );
 }
   
  async uploadedFile(event: any) {
     this.handleFileUpload(
      event,
      (file) => this.uploadToAPI(file),
      "upload_bulkUserRegister"
    );
  }
  

  uploadToAPI(file: File) {
      this.uploadFileHelper(
      (formData) =>
        this.accountService.UploadFileToBulkRegister(formData),
      file,
      (fileName) => this.downloadResultFile(fileName)
    );
  }

  
  downloadResultFile(fileName: string): void {
    this.downloadResultFileHelper(
      this.commonService.getResultFileByFileName(fileName),
      fileName,
      "Bulk user register result file download process started.",
      "Error in downloading the bulk user register result file."
    );
  }
 
}
